import { render, staticRenderFns } from "./VideosSlider.vue?vue&type=template&id=b757a08a&"
import script from "./VideosSlider.vue?vue&type=script&lang=js&"
export * from "./VideosSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports